export const ROUTE = {
  HOME: '/',
  NEWS: {
    MAIN: '/news',
    VIEW_NEWS: '/news/:id',
  },
  REVIEWS: '/reviews',
  ABOUT_US: '/about-us',
  AGREEMENT: '/agreements',
  CONTACTS: '/contacts',
  PERSONAL_ACCOUNT: '/personal-account',

  AUTH: {
    SIGN_IN: '/sign-in',
    SIGN_UP: '/sign-up',
    FORGOT_PASSWORD: '/forgot-password',
    FORGOT_PASSWORD_REQUESTED: '/forgot-password/requested',
    FORGOT_PASSWORD_CONFIRM: '/forgot-password/:id/confirm',
    FORGOT_PASSWORD_SUCCESS: '/forgot-password/success',
  },

  EXCHANGE: {
    DIRECTIONS: '/exchange/directions',
    CREATE: '/exchange/:id/create',
    ACCEPT: '/exchange/accept',
    VIEW: '/exchange/:id/view',
    STATUS: '/exchange/:id/status',
    WE_GOLD: '/deposit-wegold/:id',
  },

  ADMIN: {
    LOGIN: {
      MAIN: '/dashboard/auth/login',
    },
    ORDERS: {
      MAIN: '/dashboard/orders',
      EDIT: '/dashboard/orders/:id/edit',
      CREATE: '/dashboard/orders/create',
    },
    RESERVE_REQUESTS: {
      MAIN: '/dashboard/reserve-requests',
      EDIT: '/dashboard/reserve-requests/:id/edit',
      CREATE: '/dashboard/reserve-requests/create',
    },
    BLOCKING_DETAILS: {
      MAIN: '/dashboard/blocking-details',
      EDIT: '/dashboard/blocking-details/:id/edit',
      CREATE: '/dashboard/blocking-details/create',
    },
    EXCHANGE_DIRECTION: {
      MAIN: '/dashboard/exchange-direction',
      EDIT: '/dashboard/exchange-direction/:id/edit',
      CREATE: '/dashboard/exchange-direction/create',
    },
    REVIEWS: {
      MAIN: '/dashboard/reviews',
      EDIT: '/dashboard/reviews/:id/edit',
      CREATE: '/dashboard/reviews/create',
    },
    NEWS: {
      MAIN: '/dashboard/news',
      EDIT: '/dashboard/news/:id/edit',
      CREATE: '/dashboard/news/create',
    },
    BLOG: {
      MAIN: '/dashboard/blog',
      EDIT: '/dashboard/blog/:id/edit',
      CREATE: '/dashboard/blog/create',
    },
    CURRENCIES: {
      MAIN: '/dashboard/currencies',
      EDIT: '/dashboard/currencies/:id/edit',
      CREATE: '/dashboard/currencies/create',
    },
    CASH_EXCHANGE: {
      MAIN: '/dashboard/cash-exchanges',
      EDIT: '/dashboard/cash-exchanges/:id/edit',
      CREATE: '/dashboard/cash-exchanges/create',
    },
    USERS: {
      MAIN: '/dashboard/users',
      EDIT: '/dashboard/users/:id/edit',
      CREATE: '/dashboard/users/create',
    },
    ADMINS: {
      MAIN: '/dashboard/admins',
      EDIT: '/dashboard/admins/:id/edit',
      CREATE: '/dashboard/admins/create',
    },
  },
};
